import { useState } from "react";
import { Accordion, Button, Badge, Spinner } from "react-bootstrap";
import { FiClock, FiAward, FiRefreshCw } from "react-icons/fi";
import { useSelector } from "react-redux";
import { showToast } from "../../../../components/common/notification/Notification";
import Api from "../../../components/api/Api";
import axios from "axios";

const PlanCard = ({
  plan,
  selectedPlan,
  expandedPlan,
  setSelectedPlan, 
  setExpandedPlan,
}) => {
  // const { accessToken } = useSelector((state) => state.auth);
  const loggedInUser = useSelector((state) => state.auth.user.user);
  const [loading, setLoading] = useState(false);
  const token = loggedInUser?.refreshToken;
  const accessToken = token;
  // console.log("Plan:", plan);

  const isFree = plan.is_free_plan;
  const hasDiscount = plan.discount_percentage > 0;
  const gstIncluded = plan.gst_included;
  const isSelected = selectedPlan === plan.id;

  const eventKey = String(plan.id);

  const addSubscriptionApi = Api({
    url: "/api/payments/add/subscription",
  });

  /* HELPERS */

  const getISODate = (date) => date.toISOString();

  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  /* HANDLERS */

  const handleSelect = () => {
    setSelectedPlan(plan.id);
    setExpandedPlan(expandedPlan === plan.id ? null : plan.id);
    console.log("Selected Plan ID:", plan.id);
  };

  const handleProceed = async (e) => {
    e.stopPropagation();

    if (isFree) {
      await activateFreePlan();
    } else {
      await proceedToPayment();
    }
  };

  /* FREE PLAN */

  const activateFreePlan = async () => {
    if (loggedInUser.user?.has_used_trial) return;

    setLoading(true);

    try {
      const startDate = new Date();
      const endDate = addDays(startDate, 15);

      const payload = {
        plan_id: plan.id,
        status: "TRIAL",
        start_date: getISODate(startDate),
        end_date: getISODate(endDate),
        payment_order_id: `free_trial_${Date.now()}`,
      };

      const { data } = await addSubscriptionApi.postData(payload);

      if (data?.statusType === "SUCCESS") {
        showToast("Free trial activated successfully 🎉", {
          type: "success",
        });
      } else {
        showToast("Unable to activate free trial", {
          type: "error",
        });
      }
    } catch {
      showToast("Something went wrong while activating trial", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

/* PAID PLAN */
const proceedToPayment = async () => {
  setLoading(true);
  try {
    // Step 1: Create Payment Order
    const orderId = `order_${Date.now()}`;
    const createPayload = {
      order_id: orderId,
      order_amount: plan.price_paise / 100,
      order_currency: "INR",
      customer_details: {
        // customer_id: loggedInUser.user.id,
        customer_id: loggedInUser.user.id,
        customer_name: loggedInUser.user.first_name + " " + loggedInUser.user.last_name,
        customer_email: loggedInUser.user.email_address,
        customer_phone: loggedInUser.user.whatsapp_mobile_number,
      },
      order_meta: {
        // return_url: `allhomedesire://payment/return?order_id=${orderId}`,
        return_url: `allhomedesire://payment/return?order_id={order_id}`,
        notify_url: "https://webhook.site/test-notify-url",
      },
      order_note: `Subscription for ${plan.plan_name}`,
      plan_id: plan.id,
    };
    console.log("Create Order Payload:", createPayload);
    console.log("accessToken:", accessToken);

    const { data: orderRes } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/payments/create/order`,
      createPayload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (orderRes?.statusType !== "SUCCESS") {
      showToast("Order creation failed", { type: "error" });
      return;
    }

    // Step 2: Open Payment Gateway 
    await openPaymentGateway(orderRes);

    // Step 3: Verify Payment
    const verifyRes = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/payments/verify`,
      {
        params: {
          orderId,
          env: "dev",
          planId: plan.id,
        },
        headers: { Authorization: `Bearer ${accessToken}` },
      }
    );

    if (verifyRes?.data?.statusType !== "SUCCESS") {
      showToast("Payment verification failed", { type: "error" });
      return;
    }

    // Step 4: Activate Paid Subscription
    const startDate = new Date();
    const endDate = addDays(startDate, plan.duration_days);

    const activatePayload = {
      plan_id: plan.id,
      status: "ACTIVE",
      start_date: getISODate(startDate),
      end_date: getISODate(endDate),
      payment_order_id: orderId,
    };

    const { data: activateRes } = await addSubscriptionApi.postData(
      activatePayload
    );

    if (activateRes?.statusType === "SUCCESS") {
      showToast("Subscription activated successfully 🎉", {
        type: "success",
      });
    } else {
      showToast("Subscription activation failed", { type: "error" });
    }
  } catch (err) {
    showToast("Payment process failed", { type: "error" });
    console.error(err);
  } finally {
    setLoading(false);
  }
};

/* PAYMENT GATEWAY FUNCTION */
const openPaymentGateway = (orderData) => {
  return new Promise((resolve) => {
    if (!window.Cashfree) {
      showToast("Payment SDK not loaded", { type: "error" });
      resolve();
      return;
    }

    const options = {
      orderId: orderData.order_id,
      orderAmount: orderData.order_amount,
      orderCurrency: "INR",
      customerName: loggedInUser.user.name,
      customerEmail: loggedInUser.user.email,
      customerPhone: loggedInUser.user.phone,
      onSuccess: () => resolve(),
      onFailure: () => {
        showToast("Payment failed", { type: "error" });
        resolve();
      },
    };

    window.Cashfree.checkout(options);
  });
};


  /* RENDER */

  return (
    <Accordion.Item
      eventKey={eventKey}
      onClick={handleSelect}
      className={`mb-3 shadow-sm rounded border 
        ${isSelected ? "border-primary border-2" : ""}`}
      style={{ cursor: "pointer" }}
    >
      {/* HEADER */}
      <Accordion.Header>
        <div className="w-100 d-flex justify-content-between align-items-center">
          {/* LEFT */}
          <div className="d-flex flex-column">
            <strong className="fs-6">
              {plan.service?.name} – {plan.plan_name}
            </strong>

            <small className="text-muted">
              {plan.plan_description}
            </small>

            <div className="mt-1 d-flex gap-2">
              {isFree && <Badge bg="success">Free Trial</Badge>}

              {!isFree && plan.duration_days >= 180 && (
                <Badge bg="warning" text="dark">Best Value</Badge>
              )}

              {hasDiscount && (
                <Badge bg="danger">
                  {plan.discount_percentage}% OFF
                </Badge>
              )}
            </div>
          </div>

          {/* RIGHT PRICE */}
          <div className="text-end">
            <div className="fs-5 fw-bold">
              {isFree ? "FREE" : `₹${plan.price_paise / 100}`}
            </div>
            <small className="text-muted d-block">
              {gstIncluded ? "Inclusive of GST" : "+ GST Applicable"}
            </small>
            <small className="text-muted d-block">
              {plan.duration_days} days
            </small>
          </div>
        </div>
      </Accordion.Header>

      {/* BODY */}
      <Accordion.Body>
        {plan.offer_text && (
          <div className="alert alert-info py-2 small mb-3">
            {plan.offer_text}
          </div>
        )}

        {/* BENEFITS */}
        <div className="small mb-3">
          <div className="d-flex align-items-center mb-2">
            <FiClock className="me-2 text-primary" />
            <span>
              Validity: <strong>{plan.duration_days} days</strong>
            </span>
          </div>

          <div className="d-flex align-items-center mb-2">
            <FiAward className="me-2 text-warning" />
            <span>
              Service: <strong>{plan.service?.name}</strong>
            </span>
          </div>

          {!isFree && (
            <div className="d-flex align-items-center mb-2">
              <FiRefreshCw className="me-2 text-info" />
              <span>
                Auto-Renewal:{" "}
                <strong>
                  {plan.auto_renew ? "Enabled" : "Disabled"}
                </strong>
              </span>
            </div>
          )}
        </div>

        {/* CTA */}
        <Button
          className="w-100 py-2"
          variant={isSelected ? "primary" : "outline-primary"}
          disabled={
            loading || (isFree && loggedInUser.user?.has_used_trial)
          }
          onClick={handleProceed}
        >
          {loading ? (
            <Spinner size="sm" />
          ) : isFree && loggedInUser.user?.has_used_trial ? (
            "Free Trial Already Used"
          ) : isSelected ? (
            isFree ? "Activate Free Trial" : "Proceed to Payment"
          ) : (
            "Choose Plan"
          )}
        </Button>
      </Accordion.Body>
    </Accordion.Item>
  );
};

export default PlanCard;
 